module.exports = __webpack_public_path__ + "static/media/train.fb1c7541.svg";